import AbstractAxiosService from './AbstractAxiosService'
import { config } from '@/config'

export default class ShopmanagerService extends AbstractAxiosService {
	constructor(options = {}) {
		super(options)
		this.accumulatorCancelGroups.push("orderSubmit")
		this.headersNoCache = {
			'Cache-Control': 'no-cache',
			'Pragma': 'no-cache',
			'Expires': '0',
		}
	}

	products({ slug = "", channel = config.DEFAULT_CHANNEL, token = "", shippingCode, page = 1, limit = 399, locale = config.LOCALE, accumulatorGroup = null, deliverTime = null }) {
		//negishi-sushi?channel=negishi_basel_barfi_2&localefde_CH&limit=10&page=1

		const params = { channel, locale, limit, page };

		if (token) {
			params.token = token;
		}

		if (shippingCode) {
			params.shippingCode = shippingCode;
		}
		if (deliverTime) {
			params.deliverTime = deliverTime
		}

		return this.makeRequest("get", '/shop-api/taxon-products/by-code/:slug', {
			group: accumulatorGroup,
			path: { slug },
			params,
		})
	}

	productTags({ channel = config.DEFAULT_CHANNEL, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/products/tags', {
			group: accumulatorGroup,
			params: { channel, locale },
		})
	}

	highlightProducts({ slug = "all", channel = config.DEFAULT_CHANNEL, token = "", page = 1, limit = 199, locale = config.LOCALE, accumulatorGroup = null }) {
		//negishi-sushi?channel=negishi_basel_barfi_2&localefde_CH&limit=10&page=1

		const params = { channel, locale, limit, page, onlyHighlightProducts: 1 };

		if (token) {
			params.token = token;
		}

		return this.makeRequest("get", '/shop-api/taxon-products/by-code/:slug', {
			group: accumulatorGroup,
			path: { slug },
			params,
		})
	}

	taxons({ channel = config.DEFAULT_CHANNEL, brand, token, shippingCode, locale = config.LOCALE, accumulatorGroup = null, deliverTime = null }) {
		const params = { locale, channel };

		if (token) {
			params.token = token;
		}
		if (deliverTime) {
			params.deliverTime = deliverTime
		}

		if (shippingCode) {
			params.shippingCode = shippingCode;
		}

		return this.makeRequest("get", '/shop-api/taxons/:brand', { group: accumulatorGroup, path: { brand }, params })
	}

	productDetails({ channel = config.DEFAULT_CHANNEL, slug = "", locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/products/by-code/:slug', {
			group: accumulatorGroup,
			path: { slug },
			params: { locale, channel },
		})
	}

	productReviews({ channel = config.DEFAULT_CHANNEL, slug = '', locale = config.LOCALE, accumulatorGroup = null}) {
		return this.makeRequest("get", '/shop-api/products/by-code/:slug/reviews', {
			group: accumulatorGroup,
			path: { slug },
			params: { locale, channel },
		})
	}

	sendProductReview({slug = '', title, rating, comment, email, token = '', brand, locale = config.LOCALE, accumulatorGroup = null}) {
		const data = {
			title,
			rating,
			comment,
			email
		};
		let headers;

		if (token) {
			headers = { 'Authorization': `Bearer ${token}` };
		}


		return this.makeRequest("post", '/shop-api/products/by-code/:slug/reviews', data, {
			group: accumulatorGroup,
			path: { slug },
			params: { locale, brand },
			headers,
		})
	}

	getNextProductAvailablityChangeTime ({ channel, shippingCode, accumulatorGroup = null }) {
		return this.makeRequest('get', '/shop-api/channel/show-next-channel-pricing-availability-change/:channel', { path: { channel }, params: { shippingCode }, group: accumulatorGroup })
	}

	/*
	 * CART
	*/
	carts({ channel, zip, shippingCode, orderNow, brand, alternativeBrand, deliverTime = null, deliverTimeslot = null, planzerTimeSlot = null, campaignId = null, oldToken = null, referralToken = null, reservationHash = null, reservationUser = null, outdoorDeliveryId = null, locale = config.LOCALE }) { //we force the channel
		const data = { zip, shippingCode, orderNow, oldToken, referralToken, brand, alternativeBrand, reservationHash, reservationUser, outdoorDeliveryId }
		if (deliverTime != null) {
			data.deliverTime = deliverTime
		}
		if (deliverTimeslot != null) {
			data.deliverTimeslot = deliverTimeslot
		}
		if (planzerTimeSlot != null) {
			data.planzerTimeSlot = planzerTimeSlot
		}
		if (campaignId != null) {
			data.campaignId = campaignId
		}
		return this.makeRequest("post", '/shop-api/carts', data, { params: { channel, locale } })
	}

	cart({ token, channel, recalculate = false, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/carts/:token', { path: { token }, params: { channel, locale, recalculate }, group: accumulatorGroup })
	}

	cartOrOrder({ token, channel, recalculate = false, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/cart-or-order/:token', { path: { token }, params: { channel, locale, recalculate }, group: accumulatorGroup })
	}

	addCartItems({ token, items, channel, locale = config.LOCALE, accumulatorGroup }) {
		/* item = {
			quantity,
			productCode,
			[variantCode]
		}
		*/
		return this.makeRequest("post", '/shop-api/carts/:token/multiple-items', { items }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	updateCartItem({ token, identifier, quantity, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("put", '/shop-api/carts/:token/items/:identifier', { quantity }, { path: { token, identifier }, params: { channel, locale }, group: accumulatorGroup })
	}

	updateCartItemNotes({ token, identifier, notes, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("put", '/shop-api/carts/:token/items/:identifier/notes', { notes }, { path: { token, identifier }, params: { channel, locale }, group: accumulatorGroup })
	}

	removeCartItem({ token, identifier, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("delete", '/shop-api/carts/:token/items/:identifier', { path: { token, identifier }, params: { channel, locale }, group: accumulatorGroup })
	}

	replaceCartItemChildren({ token, identifier, childCodes, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/items/:identifier/products', { childCodes }, { path: { token, identifier }, params: { locale } })
	}

	addCoupon({ token, coupon, email, useDishes, channel, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/coupon', { coupon, email, useDishes }, { path: { token }, params: { channel, locale } })
	}

	removeCoupon({ token, channel, locale = config.LOCALE }) {
		return this.makeRequest("delete", '/shop-api/carts/:token/coupon', { path: { token }, params: { channel, locale } })
	}

	updateDeliverTime({ orderNow, deliverTime, deliverTimeslot, planzerTimeSlot, confirmChange = false, token, channel, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/delivertime', { orderNow, deliverTime, deliverTimeslot, planzerTimeSlot, confirmChange }, { path: { token }, params: { channel, locale } })
	}

	resetAdditinoalProducts({ token, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("put", '/shop-api/carts/:token/reset-additional-products', { resetAdditionalProductsModified: true }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	/*
	 * CHECKOUT
	*/
	checkoutSummary({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutAddressChange({ token, data: { shippingAddress, billingAddress }, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/address', { shippingAddress, billingAddress }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutPayments({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token/payment', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutPaymentChange({ token, method, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/payment/:id', { method }, { path: { token, id: 0 }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutShippings({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token/shipping', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutShippingChange({ token, method, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/shipping/:id', { method }, { path: { token, id: 0 }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutSubmit({ token, email, notes, orderNow, deliverTime, channel, tip, tipOption, tipMainVariant, tipSubVariant, compensateCo2, useDishes, dishReturnMethod, confirmedAlcohol, dropoffType, subscribedToNewsletter, acceptTerms, acceptPrivacy, locale = config.LOCALE, accumulatorGroup = null, userToken = null }) {
		const headers = userToken ? { 'Authorization': `Bearer ${userToken}` } : null
		return this.makeRequest(
			"put",
			'/shop-api/checkout/:token/complete',
			{ email, notes, orderNow, deliverTime, confirmedAlcohol, dropoffType, tip, tipOption, tipMainVariant, tipSubVariant, compensateCo2, subscribedToNewsletter, useDishes, dishReturnMethod, acceptTerms, acceptPrivacy },
			{ path: { token }, params: { channel, locale }, group: accumulatorGroup, headers }
		)
		///checkout/:token/complete
	}

	savedPayments({ token, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/wallee-token', { params: { locale, tokenValue: token }, group: accumulatorGroup })
	}

	deleteSavedPayment({ token, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("delete", '/shop-api/checkout/wallee-token', { data: { token }, params: { locale }, group: accumulatorGroup })
	}

	paymentTransaction({ failedUrl, successUrl, token, id, paymentToken, locale = config.LOCALE, accumulatorGroup = null }) {
		const data = { failedUrl, successUrl };

		if (paymentToken) {
			data.token = paymentToken;
		}

		return this.makeRequest("post", '/shop-api/checkout/:token/transaction/:id', data, { path: { token, id }, params: { locale }, group: accumulatorGroup })
	}

	/*
	 * ORDER
	*/
	orderShow({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/orders/:token', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	orderRestore({ token, channel, oldToken, keepOrder, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/restore/:token', { path: { token }, params: { channel, locale, oldToken, /* keepOrder */ }, group: accumulatorGroup })
	}

	createTipOrder({ token, tip, tipOption, tipMainVariant, tipSubVariant, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("post", '/shop-api/orders/create-tip-order/:token', { tip, tipOption, tipMainVariant, tipSubVariant }, { path: { token }, params: { locale }, group: accumulatorGroup })
	}

	/*
	 * LOCATION
	*/
	locationQuery({ zip, brand, deliveryMethod, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/zip/find/:brand/:method/:zip', { path: { zip, brand, method: deliveryMethod }, params: { locale } })
	}
	channels({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/channel/:brand', { path: { brand }, params: { locale }, headers: { ...this.headersNoCache }, group: accumulatorGroup })
	}
	locations({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/locations', {params: { locale, brand }, headers: { ...this.headersNoCache }, group: accumulatorGroup })
	}
	location({ channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/locations/:channel', { path: { channel }, params: { locale }, headers: { ...this.headersNoCache }, group: accumulatorGroup })
	}

	/*
	 * Account
	*/

	brands({ locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/customer/active-brands", { params: { locale }, group: accumulatorGroup })
	}

	login({ email, password, userGroup = null, userCoupon = null, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("post", '/shop-api/login', { email, password, brand, userGroup, userCoupon }, { params: { locale }, group: accumulatorGroup })
	}

	me({ brand, tokenValue, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { brand, locale }
		if (tokenValue) {
			params.tokenValue = tokenValue
		}
		return this.makeRequest("get", '/shop-api/me', { group: accumulatorGroup, params })
	}

	accountCoupons({ brand, tokenValue, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { brand, locale }
		if (tokenValue) {
			params.tokenValue = tokenValue
		}
		return this.makeRequest("get", '/shop-api/me/promotion-coupons', { group: accumulatorGroup, params })
	}

	accountUpdateMe({ brand, token, userDetail, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/me', userDetail, { group: accumulatorGroup, params: { brand, locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountClaimCoupon({ code, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/claim-coupon", { code }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountOrders({ token, channel, shippingCode = null, brand = config.BRAND, limit = 10, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { brand, limit, locale }
		if (channel) {
			params.channel = channel
		}
		if (shippingCode) {
			params.shippingCode = shippingCode
		}
		return this.makeRequest("get", '/shop-api/orders', { group: accumulatorGroup, params, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountFavoriteProducts({ token, cartToken, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/me/products', { group: accumulatorGroup, params: { token: cartToken, channel, locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountRegister({ email, password, birthday, brand, userGroup = null, userCoupon = null, subscribedToNewsletter, checkTerms, registerConfirmUrl = "",firstName = "empty", lastName = "empty", phoneNumber = "", locale = config.LOCALE }) {
		return this.makeRequest("post", '/shop-api/register', { email, registerConfirmUrl, plainPassword: password, birthday, firstName, lastName, phoneNumber, brand, userGroup, userCoupon, subscribedToNewsletter, checkTerms }, { params: { locale } })
	}

	accountRegisterConfirm({ token, brand, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/verify-account', { params: { locale, brand, token } })
	}

	accountRequestPasswordReset({ email, passwordResetUrl, brand, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/request-password-reset", { email, passwordResetUrl, brand }, { params: { locale } })
	}

	accountResetPassword({ password, confirm, token, brand, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/password-reset/:token", { password: { first: password, second: confirm } }, { path: { token }, params: { locale, brand } })
	}

	accountChangePassword({ current, password, confirm, token, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/me/change-password", { currentPassword: current, newPassword: { first: password, second: confirm } }, { params: { locale }, headers: { 'Authorization': `Bearer ${token}` } } )
	}

	accountAddresses({ token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/address-book/", { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountLastAddress({ brand, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/customer/last-address", { params: { brand, locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountUpdateAddress({ userAddress, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/update-address", userAddress, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountPoinzRegister({ brand, birthday, gender, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/poinz/register", { brand, birthday, gender }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountPoinzRedeem({ brand, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/poinz/redeem", { brand }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountGetQRToken({ token, locale = config.LOCALE }) {
		return this.makeRequest("get", "/shop-api/qr-token/token", { params: { locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountLoginWithQR({ token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", '/shop-api/qr-token/qr2jwt', { token }, { params: { locale }, group: accumulatorGroup })
	}

	accountDelete({ token, locale = config.LOCALE }) {
		return this.makeRequest("delete", '/shop-api/me/delete', { params: { locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	migrationBrands({ email, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate-brands", { email }, { params: { locale }, group: accumulatorGroup })
	}

	migrationStart({ email, brand, checkTerms, migrateVerifyUrl, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate", { email, brand, checkTerms, migrateVerifyUrl }, { params: { locale }, group: accumulatorGroup })
	}

	migrationVerify({ email, token, brand, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate-verify-email", { email, token, brand }, { params: { locale }, group: accumulatorGroup })
	}

	subscribeNewsletter({ email, firstname, lastname, brand, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/mailchimp", { email, firstname, lastname,  brand }, { params: { locale }, group: accumulatorGroup })
	}

	// RESERVATION
	reservationChannelList({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/locations/with-reservation/:brand", { params, group: accumulatorGroup, path: { brand } })
	}

	reservationList({ brand, token, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/reservation/reservations-by-brand/:brand", { params, group: accumulatorGroup, path: { brand }, headers: { 'Authorization': `Bearer ${token}` } })
	}
	reservationDetails({ brand, token, reservation, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/reservation/reservations-by-brand/:brand/:reservation", { params, group: accumulatorGroup, path: { brand, reservation }, headers: { 'Authorization': `Bearer ${token}` } })
	}
	reservationRestaurants({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/reservation/restaurants/:brand", { params, group: accumulatorGroup, path: { brand } })
	}
	reservationMonthAvailabilities({ brand, from, to, channel, seats, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale, seats, from, to };
		return this.makeRequest("get", "/shop-api/reservation/restaurants/month-availabilities/:channel", { params, group: accumulatorGroup, path: { channel } })
	}
	reservationAvailabilities({ brand, channel, seats, startSec = null, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale, seats, startSec };
		return this.makeRequest("get", "/shop-api/reservation/restaurants/availabilities/:channel", { params, group: accumulatorGroup, path: { channel } })
	}
	reservationCreate({ token, channel, seats, firstName, lastName, startSec, email, phoneNumber, roomId, roomName, notes, choices, editUrl, indining, indiningAvailable, vegiSeats, acceptTerms, acceptPrivacy, language = config.LANGUAGE, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		const data = {
			firstName,
			lastName,
			startSec,
			email,
			phoneNumber,
			notes,
			language,
			seats,
			choices,
			editUrl,
			indining,
			indiningAvailable,
			vegiSeats,
			acceptTerms,
			acceptPrivacy,
		};

		if (roomId !== undefined) {
			data.roomId = roomId;
			data.roomName = roomName;
		}
		return this.makeRequest("post", "/shop-api/reservation/reservations/:channel", data, { params, group: accumulatorGroup, path: { channel }, headers: { 'Authorization': `Bearer ${token}` } })
	}
	reservationEdit({ token, channel, reservation, seats, firstName, lastName, startSec, email, phoneNumber, roomId, roomName, notes, choices, editUrl, indining, indiningAvailable, vegiSeats, acceptTerms, acceptPrivacy, language = config.LANGUAGE, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		const data = {
			firstName,
			lastName,
			channel,
			startSec,
			email,
			phoneNumber,
			notes,
			language,
			seats,
			choices,
			editUrl,
			indining,
			indiningAvailable,
			vegiSeats,
			acceptTerms,
			acceptPrivacy,
		};

		if (roomId !== undefined) {
			data.roomId = roomId;
			data.roomName = roomName;
		}
		return this.makeRequest("put", "/shop-api/reservation/reservations/:channel/:reservation", data, { params, group: accumulatorGroup, path: { channel, reservation }, headers: { 'Authorization': `Bearer ${token}` } })
	}
	reservationCancel({ token, reservation, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("delete", "/shop-api/reservation/reservations/:reservation", { params, group: accumulatorGroup, path: { reservation }, headers: { 'Authorization': `Bearer ${token}` } })
	}
	reservationCalendar({ token, channel, reservation, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/reservation/reservations/ical/:reservation", { params, group: accumulatorGroup, path: { channel, reservation }, headers: { 'Authorization': `Bearer ${token}` } })
	}



	// SELFORDERING
	selforderingInit({ channel, deliverTime = null, orderNow = null, locale = config.LOCALE }) {
		const params = { channel, locale }
		if (deliverTime) {
			params.deliverTime = deliverTime
			params.orderNow = orderNow
		}
		return this.makeRequest('get', '/self-ordering-api/v1/init', { params })
	}

	selforderingValidateCoupon({ code, channel, deliverTime = null, orderNow = null, locale = config.LOCALE }) {
		const data = { couponCode: code }
		if (deliverTime) {
			data.deliverTime = deliverTime
			data.orderNow = orderNow
		}
		return this.makeRequest('post', '/self-ordering-api/v1/validate-coupon', data, { params: { channel, locale } })
	}

	selforderingCreateOrder({ order, channel, locale = config.LOCALE }) {
		return this.makeRequest('post', '/self-ordering-api/v1/create-order', { ...order }, { params: { channel, locale } })
	}

	// FEATURE_PLANZER_DELIVERY
	planzerDeliveryDates({ zip, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/planzer/delivery-dates/:zip', { path: { zip }, params: { locale } })
	}

	// COURSES
	loadCourseDates({courseType, brand, locale = config.LOCALE, accumulatorGroup = null}) {
		const params = { locale, brand };
		return this.makeRequest("get", "/shop-api/courses/courses-by-type/:type", { params, group: accumulatorGroup, path: { type: courseType } })
	}

	courseRegistration({ courseId, firstName, lastName, company, participants, street, streetNumber, city, postcode, email, phoneNumber, participantNames, notes, checkTerms, locale = config.LOCALE, accumulatorGroup = null }) {
		const data = {
			firstName,
			lastName,
			company,
			participants,
			street,
			streetNumber,
			city,
			postcode,
			email,
			phoneNumber,
			participantNames,
			notes,
			checkTerms,
		}
		return this.makeRequest('post', '/shop-api/courses/:id', data, { params: { locale }, group: accumulatorGroup, path: { id: courseId } })
	}

	// VOUCHERS
	loadVouchers({brand, locale = config.LOCALE, accumulatorGroup = null}) {
		const params = { locale };
		return this.makeRequest("get", "/shop-api/vouchers/:brand", { params, group: accumulatorGroup, path: { brand } })
	}

	orderVouchers({ vouchers, printAtHome, shippingAddress, billingAddress, email, notes, sendAsGift, giftSender, giftReceiver, giftMessage, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', "/shop-api/vouchers/:brand", { vouchers, printAtHome, shippingAddress, billingAddress, email, notes, sendAsGift, giftSender, giftReceiver, giftMessage }, { params: { locale }, group: accumulatorGroup, path: { brand } });
	}

	checkVoucherBalance({ cardNumber, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/boncard/balance', { cardNumber }, { params: { locale }, group: accumulatorGroup });
	}

	reloadVoucher({ cardNumber, amount, cvc, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/boncard/reload/:brand', { cardNumber, amount, cvc }, { path: { brand }, params: { locale }, group: accumulatorGroup });
	}

	// FREE PRODUCTS
	loadFreeProductPromotions({ promotionCodes, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/promotion/free-products', promotionCodes, { params: { locale }, group: accumulatorGroup });
	}

	generateFreeProductVoucher({ codes, contaoContentId, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/promotion/generate-free-products', { codes, contaoContentId }, { params: { locale }, group: accumulatorGroup });
	}

	// Outdoor Delivery
	loadOutdoorDeliveryPoints({ campaignId, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('get', '/shop-api/outdoor-deliveries/:id', { path: { id: campaignId }, params: { brand, locale }, group: accumulatorGroup });
	}

	// Group Order
	addGroupOrderParticipant({ token, name, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/carts/:token/group-order/participant', { name }, { path: { token }, params: { locale }, group: accumulatorGroup });
	}

	editGroupOrderParticipant({ token, id, name, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('put', '/shop-api/carts/:token/group-order/participant/:id', { name }, { path: { token, id }, params: { locale }, group: accumulatorGroup });
	}

	removeGroupOrderParticipant({ token, id, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('delete', '/shop-api/carts/:token/group-order/participant/:id', { path: { token, id }, params: { locale }, group: accumulatorGroup });
	}

	lockGroupOrderCart({ token, locked = true, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('put', '/shop-api/carts/:token/group-order/lock', { locked }, { path: { token }, params: { locale }, group: accumulatorGroup });
	}

	groupOrderParticipantReady({ token, id, ready = true, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('put', '/shop-api/carts/:token/group-order/participant/:id/ready', { ready }, { path: { token, id }, params: { locale }, group: accumulatorGroup });
	}

	// Escalate Error
	alert({ alertType, alertKey, alertMessage, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('post', '/shop-api/alert', { alertType, alertKey, alertMessage }, { params: { locale }, group: accumulatorGroup });
	}

	// Notime Order State
	notimeOrderState({ tokenValues, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		if (!Array.isArray(tokenValues)) {
			tokenValues = [tokenValues]
		}
		return this.makeRequest('get', '/shop-api/notime/state-by-order', { params: { tokenValues, brand, locale }, group: accumulatorGroup });
	}

	notimeOrderStateUser({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest('get', '/shop-api/notime/state-by-user', { params: { brand, locale }, group: accumulatorGroup });
	}

  // FWG
  createDonation({ amount, locale = config.LOCALE, accumulatorGroup = null }) {
    return this.makeRequest('post', '/shop-api/donations', { amount }, { params: { locale }, group: accumulatorGroup });
  }

  createPaymentFallback({ amount, channel, locale = config.LOCALE, accumulatorGroup = null }) {
    return this.makeRequest('post', '/shop-api/payment-fallbacks', { amount }, { params: { channel, locale }, group: accumulatorGroup });
  }
}
